import {BaseTerms} from "../../infrastructure/models/base-terms";

export class EntityDescriptionModuleTerms extends BaseTerms {
  ABOUT_HEADER_TEXT_ELEMENT = "About #ENTITY_NAME";
  ABOUT_HEADER_SPORT_TYPE = "#SPORT_TYPE at 365Scores";
  ENTITY_DESCRIPTION_FAQ_HEADER = "#ENTITY_NAME FAQ";
  ENTITY_INFORMATION_SHOW_LESS_BUTTON = "Show Less";
  ENTITY_INFORMATION_SHOW_MORE_BUTTON = "#ENTITY_NAAME info";
}
